import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Theme } from '@mui/material';

type Props = {
  isInstanceRunning: boolean;
  isEphemeralInstance?: boolean;
};

export const InstanceStatusIcon = ({ isInstanceRunning, isEphemeralInstance = false }: Props): JSX.Element => {
  const LocalInstanceIcon = isInstanceRunning ? RadioButtonCheckedIcon : RadioButtonUncheckedIcon;
  const Icon = isEphemeralInstance ? TimelapseIcon : LocalInstanceIcon;
  return (
    <Icon
      fontSize="small"
      sx={(theme: Theme) => ({
        color: isEphemeralInstance || isInstanceRunning ? theme.palette.success.main : theme.palette.grey[600],
        display: 'block',
      })}
    />
  );
};
